import React from 'react';
import { observer } from 'mobx-react';
import { FormWrapper, FieldsWrapper } from 'libs/forms/styles';
import { confToFields } from 'libs/forms';
import { Box, Button } from 'components';
import { BuildForm } from 'apps/build/views/buildForm';
import { formatPrice } from 'utils/formatStrings';
import SupportingFiles from 'apps/rfq/rfqPage/views/supportingFiles';
import type { ProductQuoteAppManager } from '../productQuoteAppManager';
import { Section, SectionContent } from '../../shared/layout';

const rowStyles = {
  display: 'flex',
  alignItems: 'center',
};

interface NewProductQuoteProps {
  productQuoteManager: ProductQuoteAppManager;
  inRfqPage: boolean;
}

export const NewProductQuote = observer((props: NewProductQuoteProps) => {
  const { productQuoteManager, inRfqPage } = props;
  const refs = {};
  const { jobSpecManager, productQuoteApp } = productQuoteManager;
  const { jobSpecFormStore } = jobSpecManager;

  const jobSpecFields = confToFields({
    formStore: jobSpecFormStore,
    refs,
    responsive: true,
  });

  const productQuoteFields = confToFields({
    formStore: productQuoteManager.productQuoteFormStore,
    refs,
    responsive: true,
  });

  const supportingFiles = jobSpecManager.jobSpecApp.build.supportingFiles?.apps;

  let totalCost = '-';
  if (productQuoteApp.cost && productQuoteApp.currency) {
    totalCost = formatPrice(
      productQuoteApp.cost / 100.0,
      productQuoteApp.currency,
    );
  }

  return (
    <Section title='New Part Quote'>
      <SectionContent>
        <Box sx={rowStyles}>
          <BuildForm
            jobSpecManager={jobSpecManager}
            simpleForm={true}
            refs={refs}
          />
        </Box>
      </SectionContent>
      <SectionContent>
        <Box sx={rowStyles}>
          <FormWrapper noPadding responsive>
            <FieldsWrapper formColumns={2}>
              {jobSpecFields}
              {productQuoteFields}
            </FieldsWrapper>
            <div style={{ marginTop: '20px' }}>
              <span>Total Cost:&nbsp;</span>
              <span>{totalCost}</span>
            </div>
          </FormWrapper>
        </Box>
      </SectionContent>

      {!inRfqPage && (
        <SupportingFiles
          supportingFiles={supportingFiles}
          canUpdateFiles={false}
        />
      )}
      <Box mt={8} pb={4} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          text='Save Quote'
          outline
          margin='0 24px 0 0'
          onClick={() => productQuoteApp.SetSubmitting(true)}
        />
        {/* {!inRfqPage && ( */}
        {/*  <Button */}
        {/*    text='Add to Shipment' */}
        {/*    onClick={() => { */}
        {/*      productQuoteApp.SetToAdd(true); */}
        {/*      productQuoteApp.SetSubmitting(true); */}
        {/*    }} */}
        {/*  /> */}
        {/* )} */}
      </Box>
    </Section>
  );
});
